import _slicedToArray from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import c from 'classnames';
import WysiwygField from '../../WysiwygField';

var AccordionItem = function AccordionItem(_ref) {
  var title = _ref.title,
      content = _ref.content,
      iconClassName = _ref.iconClassName;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      collapsed = _useState2[0],
      setCollapsed = _useState2[1];

  var classes = c('Accordion__item', {
    collapsed: collapsed
  });
  var iconClasses = c('icon', iconClassName);
  var contentParsed = /*#__PURE__*/React.createElement(WysiwygField, {
    html: content
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("h3", {
    className: "Accordion__item__title"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setCollapsed(!collapsed);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: iconClasses
  }), title)), /*#__PURE__*/React.createElement("div", {
    className: "Accordion__item__content"
  }, /*#__PURE__*/React.createElement("div", null, contentParsed)));
};

AccordionItem.defaultProps = {
  title: 'Default title',
  content: 'Default content',
  iconClassName: 'icon--arrow-right icon--variant-1'
};
export default AccordionItem;